import {createAsyncThunk} from '@reduxjs/toolkit';
import {toastNotificationManager} from 'toast-notifications';
import {instrumentsApi} from 'api';
import {prefix} from './config';

export const fetchPossiblePretestItemsThunk: any = createAsyncThunk(
  `${prefix} fetchPossiblePretestItems`,
  async (templateId: number, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await instrumentsApi.getPossiblePretestItems(templateId);
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
